/**
 * ReadinessChecklist - Displays project readiness status for adding bonds
 */

import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { CheckCircle } from 'lucide-react';
import type React from 'react';

interface ReadinessChecklistProps {
  hasProjectDates: boolean;
  hasTaxableValue: boolean;
  hasProjectTargets: boolean;
}

interface ChecklistItemProps {
  label: string;
  isComplete: boolean;
}

const ChecklistItem: React.FC<ChecklistItemProps> = ({ label, isComplete }) => (
  <HStack gap={2}>
    {isComplete ? (
      <Icon color="green.500" boxSize={5}>
        <CheckCircle size={20} />
      </Icon>
    ) : (
      <Box boxSize={5} borderRadius="full" borderWidth="2px" borderColor="gray.300" />
    )}
    <Text
      fontSize="sm"
      color={isComplete ? 'gray.700' : 'gray.500'}
      fontWeight={isComplete ? 'medium' : 'normal'}
    >
      {label}
    </Text>
  </HStack>
);

export const ReadinessChecklist: React.FC<ReadinessChecklistProps> = ({
  hasProjectDates,
  hasTaxableValue,
  hasProjectTargets,
}) => {
  return (
    <Box
      p={6}
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="md"
      bg="white"
      minWidth="400px"
      maxWidth="500px"
    >
      <VStack align="stretch" gap={3}>
        <ChecklistItem label="Project Dates" isComplete={hasProjectDates} />
        <ChecklistItem label="Taxable Value" isComplete={hasTaxableValue} />
        <ChecklistItem label="Project Targets (DRF and Millage)" isComplete={hasProjectTargets} />
      </VStack>
    </Box>
  );
};
